import {Injectable} from "@angular/core";

import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import { StringUtils } from '../../app/utils/StringUtils';
import { SystemApp } from '../../app/constans/SystemConfigurations';



@Injectable({
  providedIn: 'root',
})

export class ApiUrl{

  constructor(private router: Router, private activeRouter: ActivatedRoute, public http:HttpClient) {}

  private apikTenant = this.getCookie('apiKey')
  private externalURL = this.getCookie('external_apiUrl')

  public  getJWTTokenKey(): string | null{
    if(localStorage.getItem('token')){
      return localStorage.getItem('token');
    }
    return "";
  }
  public getJWTToken(){
    if(!StringUtils.isEmpty(localStorage.getItem('token'))){
      return 'Token ' + localStorage.getItem('token');
    }
    return "";
  }

  public getCookie(cname:string): string{
    const name = cname + "="
    const ca = document.cookie.split(';')
    for(let i = 0; i < ca.length; i++){
      let c = ca[i];
      while (c.charAt(0) == ' '){
        c = c.substring(1);
      }
      if(c.indexOf(name) == 0){
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }



  getIsSuperuserUrl(): string {
    return SystemApp.base_url_api + '/api/users/is_superuser/';
  }
  getUserDetails(): string {
    return SystemApp.base_url_api + '/api/users/';
  }
  loginUser(): string{
    return SystemApp.base_url_api + '/api-token-auth/'
  }
  getPages(): string{
    return SystemApp.base_url_api + '/api/pages/'
  }



}
